export default "__VITE_ASSET__1f10a55b__"